import { PaymentMethodDistribution } from "@/types/payment-history.type";
import { ChartOption } from "@/helper/chart/types/chart-option.type";
import { buildDistributionChart } from "@/helper/chart/build-distribution-chart.util";
import { chartOptionDefault } from "@/helper/chart/constants/chart-option-default.const";
import { getPaymentMethodColor } from "../colors/payment-method-color";
import { getPaymentMethodDisplayName } from "@/helper/chart/utils/payment-method-name.util";

export const getPaymentMethodsChart = (
  paymentMethods: PaymentMethodDistribution[],
  options: ChartOption = chartOptionDefault,
) => {
  return buildDistributionChart({
    items: paymentMethods,
    options,
    getLabel: (method) => getPaymentMethodDisplayName(method.payment_method),
    getColor: (method) => getPaymentMethodColor(method.payment_method),
  });
};
